import type { ProductCardData, ElevarProductItem } from 'types'

export const transformToElevarProduct = (
  item: ProductCardData
): ElevarProductItem => ({
  position: item.index,
  brand: item.item_brand,
  category: item.item_category,
  id: item.item_variant,
  list: item.item_list_name,
  name: item.item_name,
  price: item.price,
  variant: item.item_id,
})
